
import React, { useEffect, useState } from 'react';
import Loadar from '../../common/loader/Loader';
import { Table, Pagination, Button, Space, Dropdown, Menu, message , Modal, Input, Switch, Select } from 'antd';
import moment from 'moment/moment';
import { Link, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { DownloadOutlined, EditOutlined, EllipsisOutlined ,RollbackOutlined } from '@ant-design/icons';
import { reailerDistIdAgainstFillers, updateUser, getUserId } from '../../api/login/Login';

const ResellerDownLineUserList = () => {
    const  { id }= useParams()
    const [pageNumber , setPagenumber] = useState(1)
    const [data , setData ] = useState()
    const [resetKey , setResetkey] = useState(false)
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        refer_id: '',
        kycStatus: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handlePhoneChange = (e) => {
        const { value } = e.target;
        // Allow up to 10 characters only (no validation, just max length)
        if (value.length <= 10) {
            setFormData((prev) => ({ ...prev, mobile: value }));
        }
    };

    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        // console.log('Submitting filter:', formData);
        setResetkey((pre)=>!pre)
        setPagenumber(1)
       
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const resetForm = () => {
        setFormData({
            name: '',
            mobile: '',
            email: '',
            refer_id: '',
            kycStatus: '',
        });
        setResetkey((pre)=>!pre)
        setPagenumber(1)
    
    };

    useEffect(()=>{
        getUser()
    },[pageNumber , resetKey])
  

    const getUser = async()=>{
        setLoading(true)
        const body = {
            ...formData,
            id: id,
            page:pageNumber,
            count:10
        }
        try {
            let res = await reailerDistIdAgainstFillers(body)
            console.log(res  , "res")
            if(res?.error === false)
            {
                setData(res?.data)
            } 
        } catch (error) {
            
        } finally {
            setLoading(false)
        }
    
    }

    const onChangeVal = (e) => {
       
        setPagenumber(e)
    };

  // Cashback modal states
  const [cashbackModalVisible, setCashbackModalVisible] = useState(false);
  const [selectedCashbackUser, setSelectedCashbackUser] = useState(null);
  const [cashbackEnabled, setCashbackEnabled] = useState(false);
  const [cashbackChargeType, setCashbackChargeType] = useState('Percent');
  const [cashbackChargeValue, setCashbackChargeValue] = useState(0);
  const [cashbackMinAmount, setCashbackMinAmount] = useState(100);
  const [cashbackMaxAmount, setCashbackMaxAmount] = useState(50000);
  const [cashbackMinFlat, setCashbackMinFlat] = useState(10);
  const [cashbackMaxPercent, setCashbackMaxPercent] = useState(2);
  const [cashbackGstRate, setCashbackGstRate] = useState(18);
  const [cashbackGstType, setCashbackGstType] = useState("Include");
  const [cashbackUpiMinPerTxn, setCashbackUpiMinPerTxn] = useState(100);
  const [cashbackUpiMaxPerTxn, setCashbackUpiMaxPerTxn] = useState(50000);
  const [cashbackUpiDailyLimit, setCashbackUpiDailyLimit] = useState(100000);
  const [cashbackBankMinPerTxn, setCashbackBankMinPerTxn] = useState(100);
  const [cashbackBankMaxPerTxn, setCashbackBankMaxPerTxn] = useState(50000);
  const [cashbackBankDailyLimit, setCashbackBankDailyLimit] = useState(200000);
  const [cashbackModalLoading, setCashbackModalLoading] = useState(false);

  const handleCashbackModalOpen = async (record) => {
    setSelectedCashbackUser(record);
    setCashbackEnabled(Boolean(record.is_cashback_wallet_enabled));
    setCashbackChargeType(record.cashback_load_charge_type || 'Percent');
    setCashbackChargeValue(record.cashback_load_charge_value !== undefined ? record.cashback_load_charge_value : 0);
    setCashbackMinAmount(record.cashback_min_amount !== undefined ? record.cashback_min_amount : 100);
    setCashbackMaxAmount(record.cashback_max_amount !== undefined ? record.cashback_max_amount : 50000);
    setCashbackMinFlat(record.cashback_charge_min_flat !== undefined ? record.cashback_charge_min_flat : 10);
    setCashbackMaxPercent(record.cashback_charge_percent !== undefined ? record.cashback_charge_percent : (record.cashback_load_charge_value || 2));
    setCashbackGstRate(record.cashback_gst_rate !== undefined ? record.cashback_gst_rate : 18);
    setCashbackGstType(record.cashback_gst_type || "Include");
    setCashbackUpiMinPerTxn(record.cashback_upi_min_per_txn !== undefined && record.cashback_upi_min_per_txn !== null ? record.cashback_upi_min_per_txn : 500);
    setCashbackUpiMaxPerTxn(record.cashback_upi_max_per_txn !== undefined && record.cashback_upi_max_per_txn !== null ? record.cashback_upi_max_per_txn : 25000);
    setCashbackUpiDailyLimit(record.cashback_upi_daily_limit !== undefined && record.cashback_upi_daily_limit !== null ? record.cashback_upi_daily_limit : 100000);
    setCashbackBankMinPerTxn(record.cashback_bank_min_per_txn !== undefined && record.cashback_bank_min_per_txn !== null ? record.cashback_bank_min_per_txn : 500);
    setCashbackBankMaxPerTxn(record.cashback_bank_max_per_txn !== undefined && record.cashback_bank_max_per_txn !== null ? record.cashback_bank_max_per_txn : 50000);
    setCashbackBankDailyLimit(record.cashback_bank_daily_limit !== undefined && record.cashback_bank_daily_limit !== null ? record.cashback_bank_daily_limit : 200000);
    setCashbackModalVisible(true);

    try {
      if (record?._id) {
        const liveRes = await getUserId(record._id);
        const liveData = liveRes?.data?.data || liveRes?.data;
        if (liveData && (liveData.main_wallet != null || liveData.cashback_wallet != null || liveData.aeps_wallet != null)) {
          setSelectedCashbackUser(prev => ({ ...prev, ...liveData }));
          if (liveData.is_cashback_wallet_enabled !== undefined) {
            setCashbackEnabled(Boolean(liveData.is_cashback_wallet_enabled));
          }
          if (liveData.cashback_load_charge_type) {
            setCashbackChargeType(liveData.cashback_load_charge_type);
          }
          if (liveData.cashback_load_charge_value !== undefined) {
            setCashbackChargeValue(liveData.cashback_load_charge_value);
          }
          if (liveData.cashback_min_amount !== undefined) {
            setCashbackMinAmount(liveData.cashback_min_amount);
          }
          if (liveData.cashback_max_amount !== undefined) {
            setCashbackMaxAmount(liveData.cashback_max_amount);
          }
          if (liveData.cashback_charge_min_flat !== undefined) {
            setCashbackMinFlat(liveData.cashback_charge_min_flat);
          }
          if (liveData.cashback_charge_percent !== undefined) {
            setCashbackMaxPercent(liveData.cashback_charge_percent);
          }
          if (liveData.cashback_gst_rate !== undefined) {
            setCashbackGstRate(liveData.cashback_gst_rate);
          }
          if (liveData.cashback_gst_type) {
            setCashbackGstType(liveData.cashback_gst_type);
          }
          if (liveData.cashback_upi_min_per_txn !== undefined) {
            setCashbackUpiMinPerTxn(liveData.cashback_upi_min_per_txn);
          }
          if (liveData.cashback_upi_max_per_txn !== undefined) {
            setCashbackUpiMaxPerTxn(liveData.cashback_upi_max_per_txn);
          }
          if (liveData.cashback_upi_daily_limit !== undefined) {
            setCashbackUpiDailyLimit(liveData.cashback_upi_daily_limit);
          }
          if (liveData.cashback_bank_min_per_txn !== undefined) {
            setCashbackBankMinPerTxn(liveData.cashback_bank_min_per_txn);
          }
          if (liveData.cashback_bank_max_per_txn !== undefined) {
            setCashbackBankMaxPerTxn(liveData.cashback_bank_max_per_txn);
          }
          if (liveData.cashback_bank_daily_limit !== undefined) {
            setCashbackBankDailyLimit(liveData.cashback_bank_daily_limit);
          }
        }
      }
    } catch (err) {
      console.warn('Could not live fetch user details in modal:', err);
    }
  };

  const handleCashbackModalClose = () => {
    setCashbackModalVisible(false);
    setSelectedCashbackUser(null);
  };

  const handleSaveCashbackSettings = async () => {
    if (!selectedCashbackUser?._id) return;
    try {
      setCashbackModalLoading(true);
      const payload = {
        is_cashback_wallet_enabled: cashbackEnabled,
        cashback_charge_min_flat: Number(cashbackMinFlat) || 0,
        cashback_charge_percent: Number(cashbackMaxPercent) || 0,
        cashback_gst_rate: Number(cashbackGstRate) || 0,
        cashback_gst_type: cashbackGstType,
        cashback_load_charge_type: "Percent",
        cashback_load_charge_value: Number(cashbackMaxPercent) || 0,
        cashback_min_amount: Number(cashbackMinAmount) || 100,
        cashback_max_amount: Number(cashbackMaxAmount) || 50000,
        cashback_upi_min_per_txn: cashbackUpiMinPerTxn !== "" && !isNaN(cashbackUpiMinPerTxn) ? Number(cashbackUpiMinPerTxn) : 500,
        cashback_upi_max_per_txn: cashbackUpiMaxPerTxn !== "" && !isNaN(cashbackUpiMaxPerTxn) ? Number(cashbackUpiMaxPerTxn) : 25000,
        cashback_upi_daily_limit: cashbackUpiDailyLimit !== "" && !isNaN(cashbackUpiDailyLimit) ? Number(cashbackUpiDailyLimit) : 100000,
        cashback_bank_min_per_txn: cashbackBankMinPerTxn !== "" && !isNaN(cashbackBankMinPerTxn) ? Number(cashbackBankMinPerTxn) : 500,
        cashback_bank_max_per_txn: cashbackBankMaxPerTxn !== "" && !isNaN(cashbackBankMaxPerTxn) ? Number(cashbackBankMaxPerTxn) : 50000,
        cashback_bank_daily_limit: cashbackBankDailyLimit !== "" && !isNaN(cashbackBankDailyLimit) ? Number(cashbackBankDailyLimit) : 200000,
      };
      const res = await updateUser(selectedCashbackUser._id, payload);
      const isSuccess = Boolean(
        res?.user ||
        res?._id ||
        res?.statusCode == 200 ||
        res?.status === 200 ||
        res?.data ||
        res?.is_cashback_wallet_enabled !== undefined
      );

      if (isSuccess) {
        message.success('Cashback Wallet settings updated successfully!');
        getUser();
        handleCashbackModalClose();
      } else {
        message.error(res?.message || 'Failed to update settings');
      }
    } catch (err) {
      message.error(err?.response?.data?.message || err?.message || 'Failed to update settings');
    } finally {
      setCashbackModalLoading(false);
    }
  };

  const actionMenu = (record) => (
  <Menu>
    {/* <Menu.Item key="1">
      <Link to={`/admin/certificate`}>BC Authorization Letter</Link>
    </Menu.Item> */}
    <Menu.Item key="2">
      <Link to="#">ID Card</Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to="#">Certificate</Link>
    </Menu.Item>
    <Menu.Item key="4" onClick={() => {}}>
      Fund Transfer / Return
    </Menu.Item>
    <Menu.Item key="5" onClick={() => {}}>
      Scheme
    </Menu.Item>
    <Menu.Item key="6" onClick={() => {}}>
      Add Id Stock
    </Menu.Item>
    <Menu.Item key="7" onClick={() => {}}>
      Permission
    </Menu.Item>
    <Menu.Item key="8" onClick={() => {}}>
      Locked Amount
    </Menu.Item>
    <Menu.Item key="9">
      <Link to="/admin/member/profile/view/3">View Profile</Link>
    </Menu.Item>
    <Menu.Item key="10" onClick={() => handleCashbackModalOpen(record)} style={{ backgroundColor: "#faf5ff", borderTop: "1px solid #f3e8ff" }}>
      <span style={{ color: "#7c3aed", fontWeight: 700 }}>⚡ Cashback Wallet Setting</span>
    </Menu.Item>
  </Menu>
);

const reportMenu = (record) => (
  <Menu>
    <Menu.Item key="1">
      <Link to={`/admin/statement/apes/report/${record._id}`}>AEPS</Link>
    </Menu.Item>
    <Menu.Item key="2">
      <Link to={`/admin/statement/billpayment/report/${record._id}`}>Billpayment</Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to={`/admin/statement/recharge/report/${record._id}`}>Recharge</Link>
    </Menu.Item>
    <Menu.Item key="4">
      <Link to={`/admin/statement/moneyTransfer/report/${record._id}`}>Money Transfer</Link>
    </Menu.Item>
    <Menu.Item key="5">
      <Link to="/admin/report/pancard/3">UtiPancard</Link>
    </Menu.Item>
    <Menu.Item key="6">
      <Link to="/admin/statement/report/2">Account Statement</Link>
    </Menu.Item>
    {/* <Menu.Item key="7">
      <Link to="/admin/statementwallet/report/2">Aeps Statement</Link>
    </Menu.Item> */}
    <Menu.Item key="9">
      <Link to={`/admin/aepswallets/report/${record._id}`}>AEPS Wallets Reports</Link>
    </Menu.Item>
    <Menu.Item key="8">
      <Link to={`/admin/wallets/report/${record._id}`}>Main Wallets Reports</Link>
    </Menu.Item>
  </Menu>
);
  

  const columns = [
  {
    title: 'Serial No.',
    key: 'serial',
    render: (text, record, index) => {
      const serialNo = index + 1;
      return <span>{serialNo}</span>;
    },
  },
  {
    title: 'Name & Type',
    key: 'name',
    render: (text, record) => (
      <div>
        <div className="fw-bold">{record.name || '-'}</div>
        <small className="text-muted">{record.member_type || '-'}</small>
      </div>
    ),
  },
  {
    title: 'Reference Code',
    dataIndex: 'refer_id',
    key: 'refer_id',
    render: (text) => text || '-',
  },
  {
    title: 'Contact Info',
    key: 'contact',
    render: (text, record) => (
      <div>
        <div>{record.mobile || '-'}</div>
        <small className="text-muted">{record.email || '-'}</small>
      </div>
    ),
  },
  {
    title: 'Main Balance',
    dataIndex: 'main_wallet',
    key: 'main_wallet',
    render: (text) => <span>₹{text || '0'}</span>,
  },
  {
    title: 'Joining Date/Time',
    key: 'createdAt',
    render: (text, record) => (
      <div>
        <div>{record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '-'}</div>
        <small className="text-muted">
          {record.createdAt ? moment(record.createdAt).format('HH:mm:ss') : '-'}
        </small>
      </div>
    ),
  },
 
  {
    title: 'User Current Status ',
    key: 'status',
    render: (_, record) => (
      <button
        style={{ minWidth: '100px' }}
        onClick={() => {}}
        className={record?.status ? `btn btn-success` : `btn btn-danger`}
      >
        {record?.status ? 'Active' : 'Deactive'}
      </button>
    ),
  },
  {
    title: 'Status',
    key: 'is_approved',
    render: (text, record) => (
      <select
        className={`form-select form-select-sm ${record.is_approved ? 'border-success' : 'border-danger'}`}
        style={{ width: '120px' }}
        value={record.is_approved?.toString() || "false"}
        onChange={() => {}}
      >
        <option value="true">Approved</option>
        <option value="false">Not Approved</option>
      </select>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (text, record) => (
      <Space size="small" className="d-flex">
        <Dropdown overlay={actionMenu(record)} trigger={['click']}>
          <Button size="small" className="btn-action">
            Action <EllipsisOutlined />
          </Button>
        </Dropdown>
        <Dropdown overlay={reportMenu(record)} trigger={['click']}>
          <Button size="small" className="btn-report">
            Reports <EllipsisOutlined />
          </Button>
        </Dropdown>
        <Link to={`/admin/create-user/${record._id}`} className="btn btn-primary btn-sm">
          <EditOutlined />
        </Link>
      </Space>
    ),
  },
  {
    title: 'Reverse Payment',
    key: 'reversePayment',
    render: (text, record) => (
      <Button
        type="primary"
        danger
        icon={<RollbackOutlined />}
        onClick={() => {}}
      >
        Reverse
      </Button>
    ),
  },

];

  return (
    <>
    {loading && <Loadar/>}
     <div className="row m-4">
            <div className="col-xl-12" style={{ padding: 0 }}>
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0">
                                    <b>Filter Reseller Downline User</b>
                                </h4>
                            </div>                            <form
                                
                                className="row cusforms"
                                style={{ padding: 20 }}
                                onSubmit={handleSubmit}
                                onKeyDown={handleKeyDown}
                            >
                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="mobile"
                                        placeholder="Enter 10-digit mobile number"
                                        value={formData.mobile}
                                        onChange={handlePhoneChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="refer_id"
                                        placeholder={`Enter ref id`}
                                        value={formData.refer_id}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div> 

                                 <div className="form-group col-4">
                                    <select
                                        className="form-control"
                                        id="kycStatus"
                                        value={formData.kycStatus}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    >
                                        <option value="">Select KYC Status</option>
                                        <option value="verified">Verified</option>
                                        <option value="unverified">Unverified</option>
                                    </select>
                                </div> 

                            

                                <div className="form-group col-12" style={{ margin: "20px 0" }}>
                                    <button type="submit" className="btn btn-primary">
                                        SEARCH
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                        RESET
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="m-4">
      <Card>
        <Card.Header className=" active-projects style-1">
          
          <div className="w-100 tbl-caption">
                  <h4 className="heading mb-0"><b>{'Reseller Downline User'} List</b></h4>
                  <div>
                   
                    {/* <CSVLink 
                data={csvData} 
                filename={`${params?.name || 'distributor'}_list.csv`}
                className="btn btn-primary border border-white"
                style={{backgroundColor:'bs(--nav)'}}
              >
                <DownloadOutlined /> Download Excel
              </CSVLink> */}
                    
                  </div>
                </div>
        </Card.Header>
        <Card.Body className="p-0">
         
          <Table
            columns={columns}
            dataSource={data?.user || []}
            rowKey={(record) => record?._id || Math.random()}
            loading={loading}
            pagination={false}
            className="custom-table"
            scroll={{ x: true }}
          />
          <div className="p-3 d-flex justify-content-between align-items-center">
            <div>
              Total {data?.totalCount || 0} entries
            </div>
            <Pagination
              total={data?.totalCount || 0}
              onChange={onChangeVal}
              showSizeChanger={false}
              current={pageNumber}
              showQuickJumper
              
            />
          </div>
        </Card.Body>
      </Card>

      {/* Cashback Wallet Setting Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#7c3aed", fontWeight: 700, fontSize: 17 }}>
            <span>⚡ Cashback Wallet Configuration</span>
          </div>
        }
        open={cashbackModalVisible}
        visible={cashbackModalVisible}
        onCancel={handleCashbackModalClose}
        centered
        width={520}
        footer={[
          <Button key="cancel" onClick={handleCashbackModalClose} disabled={cashbackModalLoading}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={cashbackModalLoading}
            onClick={handleSaveCashbackSettings}
            style={{ backgroundColor: "#7c3aed", borderColor: "#7c3aed" }}
          >
            Save Changes
          </Button>,
        ]}
      >
        {selectedCashbackUser && (
          <div style={{ padding: "8px 0" }}>
            <div style={{ background: "#f8fafc", padding: "12px 16px", borderRadius: 8, marginBottom: 20, border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
                {selectedCashbackUser.name || "Retailer"}
              </div>
              <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
                ID / Refer Code: <span style={{ fontWeight: 600, color: "#334155" }}>{selectedCashbackUser.refer_id || selectedCashbackUser._id}</span>
                {selectedCashbackUser.mobile && <span style={{ marginLeft: 12 }}>📞 {selectedCashbackUser.mobile}</span>}
              </div>
              <div style={{ display: "flex", gap: 12, marginTop: 10, flexWrap: "wrap" }}>
                <div style={{ background: "#faf5ff", border: "1px solid #e9d5ff", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#6b21a8", fontWeight: 600 }}>Cashback Balance: </span>
                  <span style={{ fontWeight: 800, color: "#7c3aed" }}>₹{Number(selectedCashbackUser.cashback_wallet || 0).toFixed(2)}</span>
                </div>
                <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#166534", fontWeight: 600 }}>Main Wallet: </span>
                  <span style={{ fontWeight: 800, color: "#15803d" }}>₹{Number(selectedCashbackUser.main_wallet || 0).toFixed(2)}</span>
                </div>
                <div style={{ background: "#ecfeff", border: "1px solid #a5f3fc", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#155e75", fontWeight: 600 }}>AEPS Wallet: </span>
                  <span style={{ fontWeight: 800, color: "#0e7490" }}>₹{Number(selectedCashbackUser.aeps_wallet || 0).toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#0f172a" }}>Enable Cashback Wallet Service</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>Allow this retailer to view and use the Cashback Settlement suite</div>
              </div>
              <Switch
                checked={cashbackEnabled}
                onChange={(checked) => setCashbackEnabled(checked)}
                style={{ backgroundColor: cashbackEnabled ? "#7c3aed" : undefined }}
              />
            </div>

            {cashbackEnabled && (
              <div style={{ marginTop: 20, padding: 16, background: "#faf5ff", borderRadius: 8, border: "1px solid #e9d5ff" }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#581c87", marginBottom: 14 }}>
                  Load Deduction & GST Configuration
                </div>

                {/* Row 1: Min(Flat) and max(%) */}
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      Min(Flat)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="0.1"
                      value={cashbackMinFlat}
                      onChange={(e) => setCashbackMinFlat(e.target.value)}
                      placeholder="e.g. 10"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      max(%)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="0.01"
                      value={cashbackMaxPercent}
                      onChange={(e) => setCashbackMaxPercent(e.target.value)}
                      placeholder="e.g. 2 or 0.55"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                </div>

                {/* Row 2: PayOut GST (%) and Include / Exclude */}
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      PayOut GST (%)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="1"
                      value={cashbackGstRate}
                      onChange={(e) => setCashbackGstRate(e.target.value)}
                      placeholder="e.g. 18"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      Tax Mode
                    </label>
                    <Select
                      value={cashbackGstType}
                      onChange={(val) => setCashbackGstType(val)}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="Include">Include</Select.Option>
                      <Select.Option value="Exclude">Exclude</Select.Option>
                    </Select>
                  </div>
                </div>

                {/* Dynamic Live Calculation Preview */}
                {(() => {
                  const demoAmt = 100;
                  const pctFee = Number(((demoAmt * (Number(cashbackMaxPercent) || 0)) / 100).toFixed(2));
                  const baseFee = Math.max(Number(cashbackMinFlat) || 0, pctFee);
                  const gst = Number(cashbackGstRate) || 0;
                  const gstAmt = cashbackGstType === "Exclude"
                    ? Number(((baseFee * gst) / 100).toFixed(2))
                    : Number((baseFee - (baseFee / (1 + gst / 100))).toFixed(2));
                  const totalFee = cashbackGstType === "Exclude" ? Number((baseFee + gstAmt).toFixed(2)) : Number(baseFee.toFixed(2));
                  const netRec = Math.max(0, Number((demoAmt - totalFee).toFixed(2)));

                  return (
                    <div style={{ background: "#ffffff", border: "1px solid #d8b4fe", padding: "10px 12px", borderRadius: 6, fontSize: 12, color: "#6b21a8" }}>
                      <strong>Live Preview on ₹100 Load:</strong>
                      <div style={{ marginTop: 4 }}>
                        • Calculated %: <strong>₹{pctFee.toFixed(2)}</strong> vs Min(Flat): <strong>₹{(Number(cashbackMinFlat) || 0).toFixed(2)}</strong> ➔ Base: <strong>₹{baseFee.toFixed(2)}</strong>
                      </div>
                      <div style={{ marginTop: 2 }}>
                        • GST ({gst}% {cashbackGstType}): <strong>₹{gstAmt.toFixed(2)}</strong> ➔ Total Deduction: <strong>₹{totalFee.toFixed(2)}</strong>
                      </div>
                      <div style={{ marginTop: 2, color: "#166534", fontWeight: 700 }}>
                        • Retailer receives: ₹{netRec.toFixed(2)} in Cashback Wallet
                      </div>
                    </div>
                  );
                })()}

                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87", marginBottom: 10 }}>
                    Transfer Limits (Main ➔ Cashback)
                  </div>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min Amount (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackMinAmount}
                        onChange={(e) => setCashbackMinAmount(e.target.value)}
                        placeholder="e.g. 100"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max Amount (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackMaxAmount}
                        onChange={(e) => setCashbackMaxAmount(e.target.value)}
                        placeholder="e.g. 50000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#7c3aed", marginTop: 6 }}>
                    Retailer can only add amounts between ₹{cashbackMinAmount || 0} and ₹{cashbackMaxAmount || 0}.
                  </div>
                </div>

                {/* Section: UPI Payout Limits */}
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87" }}>
                      UPI Payout Limits (Cashback ➔ B2B UPI)
                    </div>
                    <span style={{ fontSize: 11, background: "#fef3c7", color: "#b45309", padding: "2px 8px", borderRadius: 4, fontWeight: 600 }}>
                      Instant UPI Rails
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiMinPerTxn}
                        onChange={(e) => setCashbackUpiMinPerTxn(e.target.value)}
                        placeholder="500"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiMaxPerTxn}
                        onChange={(e) => setCashbackUpiMaxPerTxn(e.target.value)}
                        placeholder="25000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 140px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 600, color: "#047857" }}>
                        Daily Total Limit (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiDailyLimit}
                        onChange={(e) => setCashbackUpiDailyLimit(e.target.value)}
                        placeholder="100000"
                        style={{ width: "100%", borderColor: "#a7f3d0" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#059669", marginTop: 6 }}>
                    Retailer can payout ₹{cashbackUpiMinPerTxn || 0} to ₹{cashbackUpiMaxPerTxn || 0} per UPI transaction (Max ₹{cashbackUpiDailyLimit || 0}/day).
                  </div>
                </div>

                {/* Section: Bank Transfer Payout Limits */}
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87" }}>
                      Bank Transfer Payout Limits (Cashback ➔ B2B Bank)
                    </div>
                    <span style={{ fontSize: 11, background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 4, fontWeight: 600 }}>
                      IMPS / NEFT
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankMinPerTxn}
                        onChange={(e) => setCashbackBankMinPerTxn(e.target.value)}
                        placeholder="500"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankMaxPerTxn}
                        onChange={(e) => setCashbackBankMaxPerTxn(e.target.value)}
                        placeholder="50000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 140px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 600, color: "#1d4ed8" }}>
                        Daily Total Limit (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankDailyLimit}
                        onChange={(e) => setCashbackBankDailyLimit(e.target.value)}
                        placeholder="200000"
                        style={{ width: "100%", borderColor: "#bfdbfe" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#2563eb", marginTop: 6 }}>
                    Retailer can payout ₹{cashbackBankMinPerTxn || 0} to ₹{cashbackBankMaxPerTxn || 0} per Bank transaction (Max ₹{cashbackBankDailyLimit || 0}/day).
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>   
    
    </>
  )
}

export default ResellerDownLineUserList

